import classnames from 'classnames';
import * as React from 'react';
import { scrollElementIntoView } from '../../helpers/scroll';

interface IProps {
    className?: string;
    value: string;
    placeholder: string;
    isError?: boolean;
    type?: string;
    onChange(event: React.ChangeEvent<any>): void;
    isFirstInvalidFormField?: boolean;
    testSelectorName?: string;
    mask?: any;
    maskPlaceholder?: string;
    rows?: number;
}

interface IState {
    placeholder: string;
}

export class Textarea extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            placeholder: this.props.placeholder,
        };
    }

    inputRef = null;
    getInputRef = (ref) => (this.inputRef = ref);

    handleFocus = () =>
        this.setState({ placeholder: this.props.maskPlaceholder || this.props.placeholder });

    handleBlur = () => this.setState({ placeholder: this.props.placeholder });

    shouldComponentUpdate(nextProps: IProps, nextState: IState) {
        return (
            this.props.isError !== nextProps.isError ||
            this.props.isFirstInvalidFormField !== nextProps.isFirstInvalidFormField ||
            this.props.value !== nextProps.value ||
            this.props.placeholder !== nextState.placeholder ||
            this.props.type !== nextProps.type ||
            this.props.mask !== nextProps.mask ||
            this.props.maskPlaceholder !== nextProps.maskPlaceholder ||
            this.state.placeholder !== nextState.placeholder
        );
    }

    componentDidUpdate() {
        if (this.props.isFirstInvalidFormField && this.props.isError) {
            scrollElementIntoView(this.inputRef);
        }
    }

    render() {
        const { placeholder, isError, value, rows, onChange, className } = this.props;

        const textClassName = classnames(
            'contact-input',
            'contact-text',
            { error: isError },
            className,
        );
        return (
            <textarea
                ref={this.getInputRef}
                className={textClassName}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                rows={rows}
            />
        );
    }
}
